import { render, staticRenderFns } from "./ProfileMenuMspForsageOperator.vue?vue&type=template&id=131d6c58&scoped=true&"
import script from "./ProfileMenuMspForsageOperator.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuMspForsageOperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d6c58",
  null
  
)

export default component.exports